import { removeStoredProduct } from "./storage";

let contextMenuInitialized = false;
const INQUIRY_STORAGE_KEY = "inquiry_products";

const getInquiryItems = () => {
  try {
    const items = JSON.parse(localStorage.getItem(INQUIRY_STORAGE_KEY));
    return Array.isArray(items) ? items : [];
  } catch {
    return [];
  }
};

const setInquiryItems = (items) => {
  localStorage.setItem(INQUIRY_STORAGE_KEY, JSON.stringify(items));
};

const upsertInquiryItem = (item) => {
  const currentItems = getInquiryItems();
  const exists = currentItems.some((currentItem) => String(currentItem.id) === String(item.id));
  if (exists) return false;

  setInquiryItems([...currentItems, item]);
  return true;
};

const removeInquiryItem = (id) => {
  const currentItems = getInquiryItems();
  const updatedItems = currentItems.filter((item) => String(item.id) !== String(id));
  setInquiryItems(updatedItems);
};

const syncInquiryCheckboxes = (productId, isChecked) => {
  document
    .querySelectorAll(`[data-product-inquiry="${productId}"]`)
    .forEach((checkbox) => {
      checkbox.checked = isChecked;
    });
};

const toggleInquiryBadge = (productId, isChecked) => {
  if (isChecked) return;

  const headCell = document.querySelector(`.table__head-cell[data-product-id="${productId}"]`);
  if (!headCell) return;

  const badge = headCell.querySelector('[data-inquiry-badge]');
  if (badge) {
    badge.remove();
  }
};

const toggleInquiryColumnCells = (productId, isChecked) => {
  document
    .querySelectorAll(`.table__cell[data-product-column-id="${productId}"]`)
    .forEach((cell) => {
      cell.classList.toggle("table__cell--inquiry", isChecked);
    });
};

const toggleInquiryHeadCell = (productId, isChecked) => {
  const headCell = document.querySelector(`.table__head-cell[data-product-id="${productId}"]`);
  if (!headCell) return;

  headCell.classList.toggle("table__head-cell--query", isChecked);
};

const closeAllContextMenus = () => {
  document.querySelectorAll("[data-context-menu]").forEach((menu) => {
    menu.hidden = true;
  });

  document.querySelectorAll("[data-context-toggle]").forEach((btn) => {
    btn.setAttribute("aria-expanded", "false");
  });
};

export const initContextMenu = ({ onRemove } = {}) => {
  if (contextMenuInitialized) return;
  contextMenuInitialized = true;

  document.addEventListener("change", (event) => {
    const inquiryCheckbox = event.target.closest("[data-product-inquiry]");
    if (!inquiryCheckbox) return;

    const item = {
      id: inquiryCheckbox.dataset.productInquiry,
      title: inquiryCheckbox.dataset.productTitle || "",
    };

    if (inquiryCheckbox.checked) {
      const added = upsertInquiryItem(item);

      syncInquiryCheckboxes(item.id, true);
      toggleInquiryBadge(item.id, true);
      toggleInquiryColumnCells(item.id, true);
      toggleInquiryHeadCell(item.id, true);

      window.dispatchEvent(
        new CustomEvent("inquiry:updated", {
          detail: {
            action: "add",
            added,
            item,
          },
        }),
      );
    } else {
      removeInquiryItem(item.id);

      syncInquiryCheckboxes(item.id, false);
      toggleInquiryBadge(item.id, false);
      toggleInquiryColumnCells(item.id, false);
      toggleInquiryHeadCell(item.id, false);

      window.dispatchEvent(
        new CustomEvent("inquiry:updated", {
          detail: {
            action: "remove",
            item,
          },
        }),
      );
    }
  });

  document.addEventListener("click", async (event) => {
    const removeButton = event.target.closest("[data-product-remove]");
    const toggle = event.target.closest("[data-context-toggle]");
    const menu = event.target.closest("[data-context-menu]");

    if (removeButton) {
      const productId = removeButton.dataset.productRemove;
      removeStoredProduct(productId);

      closeAllContextMenus();

      if (typeof onRemove === "function") {
        await onRemove(productId);
      }

      return;
    }

    if (toggle) {
      const wrapper = toggle.closest(".table__context-wrapper");
      const currentMenu = wrapper?.querySelector("[data-context-menu]");

      if (!currentMenu) return;

      const isOpen = !currentMenu.hidden;

      closeAllContextMenus();

      currentMenu.hidden = isOpen;
      toggle.setAttribute("aria-expanded", String(!isOpen));
      return;
    }

    if (menu) {
      return;
    }

    closeAllContextMenus();
  });
};